export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/f3df1ae07576638659e98e82c21712dc.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <h1 className="mb-6">
          <div className="text-7xl font-bold text-white mb-2 tracking-tight">Modern iOS</div>
          <div className="text-6xl font-serif italic text-white tracking-wide">Applications</div>
        </h1>
        <p className="text-xl text-white/80 font-light max-w-2xl mx-auto leading-relaxed mb-12">
          Expert team developing cutting-edge applications for the iOS platform, enhancing user experience and mobile device security
        </p>
        
        {/* App Icons */}
        <div className="flex items-center justify-center gap-4 mt-16">
          <div className="w-8 h-8 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
            <i className="ri-shield-check-line text-white text-base"></i>
          </div>
          <div className="w-8 h-8 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
            <i className="ri-speed-up-line text-white text-base"></i>
          </div>
          <div className="w-8 h-8 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
            <i className="ri-smartphone-line text-white text-base"></i>
          </div>
          <div className="w-8 h-8 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
            <i className="ri-lock-line text-white text-base"></i>
          </div>
        </div>
      </div>
    </section>
  );
}